import { ReduxFormField } from "components/molecules/ReduxFormFields/index";
import SelectCategory from "../AddFaqsForm/SelectCategory";
import SelectRedux from "components/molecules/SelectRedux";
import InputRedux from "components/molecules/InputRedux";

export { default } from "./UpdateFaqsForm";

export const fields: ReduxFormField[] = [
  {
    name: "category",
    label: "Category",
    component: SelectCategory,
    cellProps: { md: 6 },
  },
  {
    name: "status",
    label: "Status",
    component: SelectRedux,
    SelectProps: {
      options: [
        { value: "active", label: "Active" },
        { value: "blocked", label: "Blocked" },
      ],
    },
    cellProps: { md: 6 },
  },

  {
    name: "question",
    label: "Question",
    component: InputRedux,
    InputProps: { multiline: true },
    cellProps: { lg: 12 },
  },
  {
    name: "answer",
    label: "Answer",
    component: InputRedux,
    InputProps: { multiline: true },
    cellProps: { lg: 12 },
  },
];
